import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/Home.vue'
import NotFoundComponent from '../views/404.vue'
import { getToken } from 'common/user.js'

Vue.use(VueRouter)
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

const routes = [
  {
    path: '/index.html', // * 表示上面路径匹配不到的都显示这个页面
    name: 'NotFoundComponent',
    component: NotFoundComponent
  },
  // 404页面
  {
    path: '*', // * 表示上面路径匹配不到的都显示这个页面
    name: 'NotFoundComponent',
    component: NotFoundComponent
  },
  {
    path: '/',
    name: 'Home',
    meta: {
      title: '首页 - 粤桥工科' // 页面标题
    },
    component: Home,
    children: [
      {
        path: '/home',
        name: 'main_home',
        meta: {
          title: '首页 - 粤桥工科'
        },
        component: () => import(/* webpackChunkName: "main_home" */ 'views/main_home')
      },
      {
        path: '/projectList',
        name: 'projectList',
        meta: {
          title: '项目展示 - 粤桥工科'
        },
        component: () => import(/* webpackChunkName: "projectList" */ 'views/projectList/index')
      },
      {
        path: '/projectList_detail',
        name: 'projectList_detail',
        meta: {
          title: '典型业绩展示 - 粤桥工科'
        },
        component: () => import(/* webpackChunkName: "projectList" */ 'views/projectList/detail')
      },
      {
        path: '/news',
        name: 'news',
        meta: {
          title: '新闻列表 - 粤桥工科'
        },
        component: () => import(/* webpackChunkName: "news" */ 'views/news/index')
      },
      {
        path: '/news_detail',
        name: 'news_detail',
        meta: {
          title: '新闻详情 - 粤桥工科'
        },
        component: () => import(/* webpackChunkName: "news" */ 'views/news/detail')
      },
      {
        path: '/about_us',
        name: 'about_us',
        meta: {
          title: '关于我们 - 粤桥工科'
        },
        component: () => import(/* webpackChunkName: "about_us" */ 'views/about_us')
      },
      {
        path: '/business',
        name: 'business',
        meta: {
          title: '业务介绍 - 粤桥工科'
        },
        component: () => import(/* webpackChunkName: "business" */ 'views/business/index')
      },
      {
        path: '/struct_analyse',
        name: 'struct_analyse',
        meta: {
          title: '业务介绍-工程结构分析 - 粤桥工科'
        },
        component: () => import(/* webpackChunkName: "struct_analyse" */ 'views/struct_analyse')
      },
      {
        path: '/struct_moni',
        name: 'struct_moni',
        meta: {
          title: '业务介绍-工程结构监测 - 粤桥工科'
        },
        component: () => import(/* webpackChunkName: "struct_moni" */ 'views/struct_moni')
      },
      {
        path: '/struct_tech',
        name: 'struct_tech',
        meta: {
          title: '业务介绍-工程信息技术 - 粤桥工科'
        },
        component: () => import(/* webpackChunkName: "struct_tech" */ 'views/struct_tech')
      },
      {
        path: '/struct_dev',
        name: 'struct_dev',
        meta: {
          title: '业务介绍-工程科技研发 - 粤桥工科'
        },
        component: () => import(/* webpackChunkName: "struct_dev" */ 'views/struct_dev')
      },

      // {
      //   path: '/test',
      //   name: 'test',
      //   meta: {
      //     title: '测试页 - 粤桥工科'
      //   },
      //   component: () => import(/* webpackChunkName: "test" */ 'views/test')
      // }, 
    ]
  },
  {
    path: '/layout',
    name: 'layout',
    meta: {
      title: '首页 - 粤桥工科' // 页面标题
    },
    component: () => import(/* webpackChunkName: "layout" */ 'views/Layout'),
    children: [
      {
        path: '/newindex',
        name: 'new_home',
        meta: {
          title: '首页 - 粤桥工科'
        },
        component: () => import(/* webpackChunkName: "main_home" */ 'views/main_home/newindex')
      },
      {
        path: '/newNews',
        name: 'new_News',
        meta: {
          title: '最新消息 - 粤桥工科'
        },
        component: () => import(/* webpackChunkName: "news" */ 'views/news/newindex')
      },
      {
        path: '/innovation',
        name: 'innovation',
        meta: {
          title: '科研创新 - 粤桥工科'
        },
        component: () => import(/* webpackChunkName: "innovation" */ 'views/innovation/index')
      },
      {
        path: '/participants',
        name: 'participants',
        meta: {
          title: '优秀科技工作者介绍 - 粤桥工科'
        },
        component: () => import(/* webpackChunkName: "innovation" */ 'views/innovation/participants')
      },
      {
        path: '/innovation_detail',
        name: 'innovation_detail',
        meta: {
          title: '研究项目与成果 - 粤桥工科'
        },
        component: () => import(/* webpackChunkName: "innovation" */ 'views/innovation/detail')
      },
      {
        path: '/nabout_us',
        name: 'newabout_us',
        meta: {
          title: '关于我们 - 粤桥工科'
        },
        component: () => import(/* webpackChunkName: "about_us" */ 'views/about_us/newindex')
      },
      {
        path: '/nprojectList',
        name: 'newprojectList',
        meta: {
          title: '项目展示 - 粤桥工科'
        },
        component: () => import(/* webpackChunkName: "projectList" */ 'views/projectList/newindex')
      },
      {
        path: '/nprojectList_detail',
        name: 'newprojectList_detail',
        meta: {
          title: '典型业绩展示 - 粤桥工科'
        },
        component: () => import(/* webpackChunkName: "projectList" */ 'views/projectList/newdetail')
      },
      {
        path: '/nbusiness',
        name: 'newbusiness',
        meta: {
          title: '业务介绍 - 粤桥工科'
        },
        component: () => import(/* webpackChunkName: "business" */ 'views/business/newindex')
      },
      {
        path: '/nstruct_analyse',
        name: 'newstruct_analyse',
        meta: {
          title: '业务介绍-工程结构分析 - 粤桥工科'
        },
        component: () => import(/* webpackChunkName: "struct_analyse" */ 'views/struct_analyse/newindex')
      },
      {
        path: '/nstruct_moni',
        name: 'newstruct_moni',
        meta: {
          title: '业务介绍-工程结构监测 - 粤桥工科'
        },
        component: () => import(/* webpackChunkName: "struct_moni" */ 'views/struct_moni/newindex')
      },
      {
        path: '/nstruct_tech',
        name: 'newstruct_tech',
        meta: {
          title: '业务介绍-工程信息技术 - 粤桥工科'
        },
        component: () => import(/* webpackChunkName: "struct_tech" */ 'views/struct_tech/newindex')
      }
    ]
  },
  {
    path: '/agreement',
    name: 'agreement',
    meta: {
      title: '注册协议 - 粤桥工科'
    },
    component: () => import(/* webpackChunkName: "agreement" */ 'views/agreement')
  }, 
  {
    path: '/user',
    name: 'user',
    meta: {
      title: '用户 - 粤桥工科',
      // isLogin: true
    },
    component: () => import(/* webpackChunkName: "user" */ 'views/user/index'),
    children: [
      {
        path: '/bbs',
        name: 'bbs',
        meta: {
          title: '校友圈 - 粤桥工科',
          isLogin: true
        },
        component: () => import(/* webpackChunkName: "user" */ 'views/user/bbs')
      },
      {
        path: '/events',
        name: 'events',
        meta: {
          title: '活动 - 粤桥工科',
          isLogin: true
        },
        component: () => import(/* webpackChunkName: "user" */ 'views/user/events')
      },
      {
        path: '/sign',
        name: 'sign',
        meta: {
          title: '登录注册 - 粤桥工科'
        },
        component: () => import(/* webpackChunkName: "user" */ 'views/user/sign')
      },
      {
        path: '/forget_password',
        name: 'forget_password',
        meta: {
          title: '忘记密码 - 粤桥工科'
        },
        component: () => import(/* webpackChunkName: "user" */ 'views/user/forget_password')
      },
      {
        path: '/user_information',
        name: 'user_information',
        meta: {
          title: '用户信息 - 粤桥工科',
          isLogin: true
        },
        component: () => import(/* webpackChunkName: "user" */ 'views/user/user_information')
      },
      {
        path: '/modify_password',
        name: 'modify_password',
        meta: {
          title: '修改密码 - 粤桥工科',
          isLogin: true
        },
        component: () => import(/* webpackChunkName: "user" */ 'views/user/modify_password')
      }, 
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes: routes,
  scrollBehavior (to, from, savedPosition) {
    // history.pushState(null, null, document.URL);
    if(savedPosition) {
      return savedPosition
    }
    else{
      return {x:0,y:0}
    }
  }
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  if (to.matched.some(res => to.meta.isLogin)) { // 判断是否需要登录
    if (getToken()) {
      next()
    } else {
      next({
        path: '/sign',
        query: {
          redirect: to.fullPath
        }
      })
      // window.location.reload()
    }
  } else {
    next()
  }
})

export default router
